import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ButtonAction } from '../../component-button-action';
import { Plus } from '../../component-icons';
import { forwardRef } from 'react';
export const ProductTeaserMiniContentButtonAction = forwardRef(({ ...props }, ref) => {
    return _jsx(ButtonAction, { size: "sm", icon: Plus, ...props, ref: ref });
});
ProductTeaserMiniContentButtonAction.displayName =
    'ProductTeaserMiniContentButtonAction';
